var map = {
	"./1inch.svg": 90552,
	"./777xbet.svg": 95561,
	"./7xbt.svg": 44596,
	"./aave.svg": 71086,
	"./ach.svg": 53773,
	"./ada.svg": 87401,
	"./aevo.svg": 88264,
	"./agix.svg": 38240,
	"./ai.svg": 41821,
	"./akro.svg": 7098,
	"./algo.svg": 99594,
	"./alpaca.svg": 83681,
	"./alt.svg": 91532,
	"./ape.svg": 7313,
	"./api3.svg": 93548,
	"./apt.svg": 16688,
	"./arb.svg": 65976,
	"./ark.svg": 38929,
	"./arkm.svg": 97686,
	"./astr.svg": 74425,
	"./atom.svg": 9064,
	"./avax.svg": 49661,
	"./axs.svg": 1063,
	"./bat.svg": 51320,
	"./bch.svg": 7130,
	"./blur.svg": 84712,
	"./blz.svg": 12913,
	"./bnb.svg": 3827,
	"./bnt.svg": 41469,
	"./bome.svg": 53620,
	"./bonk.svg": 67691,
	"./btc.svg": 17808,
	"./btt.svg": 25311,
	"./c98.svg": 65145,
	"./cake.svg": 38339,
	"./celo.svg": 32748,
	"./chr.svg": 82244,
	"./chz.svg": 22956,
	"./clv.svg": 90292,
	"./comp.svg": 70422,
	"./crv.svg": 30094,
	"./cvc.svg": 75399,
	"./cyber.svg": 63950,
	"./dai.svg": 81591,
	"./dash.svg": 19583,
	"./doge.svg": 32628,
	"./dot.svg": 74352,
	"./dydx.svg": 54350,
	"./dym.svg": 74867,
	"./egld.svg": 41799,
	"./ens.svg": 68105,
	"./eos.svg": 64630,
	"./etc.svg": 20023,
	"./eth.svg": 54700,
	"./fet.svg": 51024,
	"./fil.svg": 65700,
	"./floki.svg": 38968,
	"./flow.svg": 19551,
	"./ftm.svg": 68666,
	"./gala.svg": 60170,
	"./glm.svg": 40531,
	"./gmx.svg": 13081,
	"./google-button.svg": 97519,
	"./grt.svg": 11912,
	"./hbar.svg": 73656,
	"./hifi.svg": 58917,
	"./hook.svg": 43190,
	"./hot.svg": 78244,
	"./icp.svg": 10701,
	"./icx.svg": 31205,
	"./id.svg": 92880,
	"./imx.svg": 81875,
	"./inj.svg": 70188,
	"./iotx.svg": 29359,
	"./jto.svg": 88956,
	"./jup.svg": 45896,
	"./kava.svg": 5724,
	"./klay.svg": 64384,
	"./knc.svg": 79175,
	"./ldo.svg": 61666,
	"./lina.svg": 55209,
	"./link.svg": 8723,
	"./lpt.svg": 47533,
	"./lqty.svg": 1279,
	"./lrc.svg": 86520,
	"./ltc.svg": 8854,
	"./magic.svg": 8604,
	"./mana.svg": 19958,
	"./manta.svg": 93616,
	"./mask.svg": 15699,
	"./matic.svg": 65175,
	"./mav.svg": 12757,
	"./meme.svg": 21771,
	"./mkr.svg": 28843,
	"./mwc.svg": 78246,
	"./near.svg": 98925,
	"./neo.svg": 45203,
	"./nexo.svg": 16611,
	"./nkn.svg": 96432,
	"./ocean.svg": 39739,
	"./ogn.svg": 9101,
	"./omg.svg": 57238,
	"./ont.svg": 39996,
	"./op.svg": 98262,
	"./oxt.svg": 30590,
	"./pendle.svg": 50509,
	"./people.svg": 73818,
	"./pepe.svg": 53223,
	"./pivx.svg": 17516,
	"./pols.svg": 52191,
	"./portal.svg": 29593,
	"./pyth.svg": 35178,
	"./qnt.svg": 19634,
	"./qtum.svg": 24698,
	"./rdnt.svg": 36483,
	"./ren.svg": 4614,
	"./rndr.svg": 56085,
	"./rvn.svg": 28191,
	"./sand.svg": 52849,
	"./sei.svg": 83668,
	"./sfm.svg": 69505,
	"./shib.svg": 20895,
	"./skl.svg": 68815,
	"./snx.svg": 16484,
	"./sol.svg": 63371,
	"./ssv.svg": 63117,
	"./stg.svg": 17725,
	"./strk.svg": 13387,
	"./sui.svg": 45476,
	"./sushi.svg": 70447,
	"./telegram-button.svg": 4639,
	"./tether-icon.svg": 2647,
	"./tezos.svg": 66238,
	"./theta.svg": 12393,
	"./tia.svg": 87613,
	"./tnsr.svg": 20742,
	"./ton.svg": 52778,
	"./trb.svg": 38753,
	"./trx.svg": 86315,
	"./try.svg": 81050,
	"./tusd.svg": 74895,
	"./uni.svg": 79155,
	"./usdc.svg": 19068,
	"./usdt.svg": 94579,
	"./vet.svg": 31840,
	"./vext.svg": 12944,
	"./w.svg": 33186,
	"./wif.svg": 22267,
	"./wld.svg": 84490,
	"./woo.svg": 26700,
	"./xai.svg": 11147,
	"./xaut.svg": 69841,
	"./xdc.svg": 32954,
	"./xem.svg": 5179,
	"./xlm.svg": 7012,
	"./xmr.svg": 91604,
	"./xrp.svg": 58391,
	"./zen.svg": 65550,
	"./zeta.svg": 5693,
	"./zil.svg": 72048,
	"./zrx.svg": 63693
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28363;